<template>
  <ContentWrapper>
    <div class="content">
      <p>
        👋 My name is <b>Erlend Gjesteland Ekern</b>. I researched and developed
        the IMPGAN architecture as part of my master's thesis "<i
          >Information Maximizing and Pattern-Producing Generative Adversarial
          Networks</i
        >" (a mouthful!) in Artificial Intelligence at the Norwegian University
        of Science and Technology.
      </p>
      <p>
        Connect with me on Twitter
        <a href="https://twitter.com/erlendekern">@erlendekern</a> or email (<i
          >firstname</i
        >
        @ <i>lastname</i>.me) if you have any questions or comments, or if you
        want to share something cool you (or the IMPGAN 😉) created 🌈
      </p>
    </div>
  </ContentWrapper>
</template>

<script>
import ContentWrapper from "./ContentWrapper.vue"
export default {
  name: "Contact",
  components: {
    ContentWrapper
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../style/variables.scss";

a {
  color: white;
}

.content {
  font-family: monospace;
  max-height: 50vh;
  overflow-y: auto;
  font-size: 1.3em;
}

@media (max-width: 767px) {
  .content {
    font-size: 1em;
  }
}
</style>
